<template>
    <v-row
        no-gutters
        class="pl-9 pt-8"
    >
        <v-col cols="8">
            <div>
                <div class="font-weight-medium title">
                    {{ $t("Be aware of the issues before they become problems") }}
                </div>
                <div
                    class="body-2 wrap pt-2"
                    v-html="$options.filters.nl2br(description)"
                ></div> <!-- INPUT FROM STATIC TRANSLATION -->
            </div>
        </v-col>
        <v-col cols="4">
            <AppStoreDialogSidebar />
        </v-col>
    </v-row>
</template>

<script>
import { $t } from "@/i18n";
import AppStoreDialogSidebar from "@/components/AppStore/AppStoreDialogSidebar";
import AppModule from "@/store/modules/app";

export default {
    name: "MonitoringDialogOverviewTab",
    components: {
        AppStoreDialogSidebar
    },
    setup() {
        const description = $t(
            "<ul><li>Real time comparison of client contract and actual work done;</li><li>Be aware of the issues before they become problems;</li><li>Even with fixed prices you need to have internal measurements. Monitor the validity of the client’s agreement by comparing it with the actual amount of work done.</li></ul>"
        );
        return {
            description
        };
    }
};
</script>
